import { render, staticRenderFns } from "./upload-some.vue?vue&type=template&id=70db8fb4&scoped=true"
import script from "./upload-some.vue?vue&type=script&lang=js"
export * from "./upload-some.vue?vue&type=script&lang=js"
import style0 from "./upload-some.vue?vue&type=style&index=0&id=70db8fb4&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"
import style1 from "./upload-some.vue?vue&type=style&index=1&id=70db8fb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db8fb4",
  null
  
)

export default component.exports